import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import UserCard from 'flarum/forum/components/UserCard';
import UserControls from 'flarum/forum/utils/UserControls';
import StatusModal from './components/StatusModal';
const m = window.m;
function statusButton(user) {
  return m(Button, {
    icon: 'fas fa-grin',
    onclick: () => {
      app.modal.show(StatusModal, {
        user
      });
    }
  }, app.translator.trans('clarkwinkelmann-status.forum.menu.set-status'));
}
app.initializers.add('clarkwinkelmann-status', () => {
  extend(SessionDropdown.prototype, 'items', function (items) {
    const user = app.session.user;
    if (user && user.attribute('clarkwinkelmannStatusCanEdit')) {
      items.add('clarkwinkelmann-status', statusButton(user));
    }
  });
  extend(UserControls, 'userControls', function (items, user) {
    if (user.attribute('clarkwinkelmannStatusCanEdit')) {
      items.add('clarkwinkelmann-status', statusButton(user));
    }
  });
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    const emoji = user.attribute('clarkwinkelmannStatusEmoji');
    const text = user.attribute('clarkwinkelmannStatusText');
    if (!emoji && !text) {
      return;
    }
    items.add('clarkwinkelmann-status', m('.ClarkWinkelmannStatus', [emoji ? m('span.ClarkWinkelmannStatusEmoji', emoji) : null, text ? m('span.ClarkWinkelmannStatusText', text) : null]), -100);
  });
});